var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeletePerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Delete_Person",
    "data-name": "Delete Person",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 112.434,
    height: 163.867,
    viewBox: "0 0 112.434 163.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_561",
    x: 66.934,
    y: 9.5,
    width: 47,
    height: 47,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4113",
    "data-name": "Rectangle 4113",
    width: 86.923,
    height: 163.867,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_561-2",
    "data-name": "Ellipse 561",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(68.43 10)",
    fill: "#56aa1c"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_238",
    x: 66.934,
    y: 9.5,
    width: 47,
    height: 47,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31531",
    "data-name": "Rectangle 31531",
    width: 35.737,
    height: 37.146,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11450",
    "data-name": "Group 11450",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11449",
    "data-name": "Group 11449",
    transform: "translate(0 -0.003)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11633",
    "data-name": "Path 11633",
    d: "M106.144,850.986H36.674a7.815,7.815,0,0,0-7.815,7.815l5.21,94.481a7.815,7.815,0,0,0,7.815,7.815h59.049a7.815,7.815,0,0,0,7.815-7.815l5.21-94.481a7.815,7.815,0,0,0-7.815-7.815M50.9,953.586c-.109.008-.217.01-.326.01a5.209,5.209,0,0,1-5.195-4.89l-5.21-84.687a5.21,5.21,0,0,1,10.4-.641l5.21,84.688a5.21,5.21,0,0,1-4.879,5.521m25.715-5.2a5.21,5.21,0,1,1-10.42,0V863.7a5.21,5.21,0,1,1,10.42,0Zm20.817.321a5.209,5.209,0,0,1-5.195,4.89c-.108,0-.216,0-.326-.01a5.21,5.21,0,0,1-4.879-5.521l5.21-84.687a5.21,5.21,0,0,1,10.4.641Z",
    transform: "translate(-27.036 -797.23)",
    fill: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11634",
    "data-name": "Path 11634",
    d: "M9.8,42.481l64.946-29.2A6.945,6.945,0,0,0,69.045.61L4.1,29.812A6.945,6.945,0,1,0,9.8,42.481M22.962,16.706,46.722,6.022a5.848,5.848,0,0,1,5.643.481l3.89-1.749a9.75,9.75,0,0,0-11.136-2.3L21.359,13.142A9.75,9.75,0,0,0,15.686,23l3.89-1.749a5.848,5.848,0,0,1,3.385-4.54",
    transform: "translate(0 0.003)",
    fill: "#3b3b3b"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_94",
    "data-name": "Mask Group 94",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11448",
    "data-name": "Group 11448",
    transform: "translate(6230.692 12172.259)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6230.69, -12172.26)",
    filter: "url(#Ellipse_238)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_238-2",
    "data-name": "Ellipse 238",
    cx: 22,
    cy: 22,
    r: 22,
    transform: "translate(68.43 10)",
    fill: "#56aa1c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12673",
    "data-name": "Group 12673",
    transform: "translate(-6158.127 -12153.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12672",
    "data-name": "Group 12672",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38484",
    "data-name": "Path 38484",
    d: "M31.272,8.9a8.9,8.9,0,1,1-8.9-8.9,8.9,8.9,0,0,1,8.9,8.9",
    transform: "translate(-4.506 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38485",
    "data-name": "Path 38485",
    d: "M24.117,28.516a10.611,10.611,0,0,1-12.5,0C6.321,30.884,2.1,36.177.139,42.881c-.537,1.84.55,3.8,2.086,3.8H33.511c1.537,0,2.625-1.959,2.086-3.8-1.959-6.7-6.182-12-11.48-14.365",
    transform: "translate(0 -9.533)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletePerson);
export default __webpack_public_path__ + "static/media/Delete Person.d7a1e2f7e5c18807f49fba2eeed0807c.svg";
export { ForwardRef as ReactComponent };